'use client';

import "../../styles/WAButton/WAButton.css"

export default function WAButton() {
    const WA_NUMBER = "6282330779799";
    const WA_TEXT = "Halo saya tertarik dengan produk Wooblazz. Apa boleh didemokan dan diinfokan lebih lanjut? _[Compro Wooblazz > WA]_";
    const encodedMessage = encodeURIComponent(WA_TEXT);
    const WA_LINK = `https://api.whatsapp.com/send?phone=${WA_NUMBER}&text=${encodedMessage}`;

    return (
        <button className="sora wa-shortcut-button" onClick={() => window.open(WA_LINK, "_blank")}>
            <span className="wa-tooltip-text">
                Konsultasi<br />Sekarang!
            </span>

            <div className="wa-icon-container">
                <img
                    src="/assets/icons/whatsapp-green.png"
                    alt="wa-button"
                    width={63}
                    height={63}
                />
            </div>
        </button>
    );
}